/**
 * Represents a custom tab element.
 * @class
 * @extends HTMLElement
 */
class TabItem extends HTMLElement {
  /**
   * Called when the element is connected to the DOM.
   * Adds a click event listener to activate the tab.
   */
  connectedCallback() {
    this.addEventListener('click', () => {
      this.setActive();
    });
  }

  /**
   * @param {NodeList} nodes
   * @returns {Array<HTMLElement>}
   *
   */
  toArray(nodes) {
    return Array.prototype.slice.call(nodes);
  }

  /**
   * @param {string} selector
   */
  getElements(selector, context = document) {
    return context ? this.toArray(context.querySelectorAll(selector)) : [];
  }

  /**
   * @param {string} selector
   */
  getElement(selector, context = document) {
    return this.getElements(selector, context)[0];
  }

  /**
   * Activates the tab and shows the associated panel.
   */
  setActive() {
    const target = this.getAttribute('data-tab-panel') || '';
    const activeClass = this.dataset.tabActiveClass || 'is-active';
    const tabs = this.getElements('tab-item');
    const panels = this.getElements('tab-panel');

    tabs.forEach((tab) => tab.classList.remove(activeClass));
    panels.forEach((panel) => (panel.style.display = 'none'));

    this.classList.add(activeClass);
    const panel = this.getElement(target);

    panel.style.display = 'block';
  }
}

/**
 * Represents a custom panel element.
 * @class
 * @extends HTMLElement
 */
class TabPanel extends HTMLElement {
  /**
   * Called when the element is connected to the DOM.
   * Hides the panel initially.
   */
  connectedCallback() {}
}

if (!customElements.get('tab-item')) {
  customElements.define('tab-item', TabItem);
}
if (!customElements.get('tab-panel')) {
  customElements.define('tab-panel', TabPanel);
}
